import { styled } from "@mui/material";
import { DayContainer } from "./DayContainer";

export const DayButton = styled(DayContainer)({
    height: '38px',
    width: '38px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: '#f9f9f9'
    }
})